<template>
  <b-container fluid class="management-container animated fadeIn">
    <b-row align-h="start" align-v="center">
      <b-col>
        <h2>{{ uniTranslation("GON94") }}</h2>
      </b-col>
      <b-col>
        <b-button
          v-show="!fromAddToOffer"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          @click="createNewOffer"
        >
          {{ uniTranslation("GO61") }} </b-button
        >&nbsp;
        <b-button
          v-show="!fromAddToOffer"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          @click="setActiveOffer"
        >
          {{ uniTranslation("GON104") }} </b-button
        >&nbsp;
        <b-button
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          @click="esportaCSVOffers"
          >{{ uniTranslation("GON95") }}</b-button
        >
        <!--<download-csv class="btn btn-success" :data="items" name="export.csv" separator-excel>
          {{ uniTranslation("GON95") }} </download-csv
        >-->
        &nbsp;
        <b-button
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          @click="showSearchPanel = !showSearchPanel"
          >{{ uniTranslation("GON96") }}</b-button
        >
      </b-col>
    </b-row>
    <div v-if="showSearchPanel">
      <b-row>
        <div class="col-12">
          <hr />
        </div>
      </b-row>
      <b-row>
        <b-col cols="2">
          <h3>{{ uniTranslation("GCN36") }}</h3>
        </b-col>
        <b-col>
          <b-form-group
            label-cols="4"
            label-cols-lg="2"
            :label="uniTranslation('GO032')"
            label-for="txtOfferNumber"
          >
            <b-form-input id="txtOfferNumber" v-model="offerNumberToSearch"></b-form-input>
          </b-form-group>

          <b-form-group
            label-cols="4"
            label-cols-lg="2"
            :label="uniTranslation('GO034')"
            label-for="txtOfferDescriptionT"
          >
            <b-form-input
              id="txtOfferDescriptionT"
              v-model="offerDescriptionToSearch"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label-cols="4"
            label-cols-lg="2"
            :label="uniTranslation('PHE611')"
            label-for="txtCompanyname"
          >
            <b-form-input id="txtCompanyname" v-model="companyNameToSearch"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="4"
            label-cols-lg="2"
            :label="uniTranslation('S1102')"
            label-for="txtAttention"
          >
            <b-form-input id="txtAttention" v-model="attentionToSearch"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <div class="col-12">
        <hr />
      </div>
    </b-row>

    <div class="row">
      <!-- =================================================== -->
      <!-- SEZIONE FILTRI -->
      <div class="col-4">
        <b-form-group
          :label="uniTranslation('TTL_FILTER')"
          label-for="offer-filter-cipriani-fake"
          label-cols-sm="1"
          label-align-sm="left"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="offer-filter-input-cipriani-fake"
              v-model="filterFake"
              type="search"
              :placeholder="uniTranslation('DESC_FILTER')"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filterFake" @click="filterFake = ''"
                ><i class="fa-solid fa-filter-circle-xmark"></i
              ></b-button>
              <b-button @click="filterOffers"
                ><i class="fa-solid fa-magnifying-glass"></i
              ></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <br />
      </div>

      <div class="col-4" v-show="false">
        <b-form-group
          label="Filter"
          label-for="offer-filter-cipriani-real"
          label-cols-sm="1"
          label-align-sm="left"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="offer-filter-input-cipriani-real"
              v-model="filter"
              :title="uniTranslation('TTL_FILTER')"
              :placeholder="uniTranslation('DESC_FILTER')"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"
                ><i class="fa-solid fa-filter-circle-xmark"></i
              ></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <br />
      </div>
      <div class="col-4">
        <b-form-group
          v-show="false"
          label="Filter On"
          description="Leave all unchecked to filter on all data"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-checkbox-group v-model="filterOn" class="mt-1">
            <b-form-checkbox value="id">Id</b-form-checkbox>
            <b-form-checkbox value="offerNumber"> {{ uniTranslation("GO032") }}</b-form-checkbox>
            <b-form-checkbox value="offerDescription">
              {{ uniTranslation("GO034") }}</b-form-checkbox
            >
            <b-form-checkbox value="companyName">{{ uniTranslation("PHE611") }}</b-form-checkbox>
            <b-form-checkbox value="attention">{{ uniTranslation("S1102") }}</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
      <div class="col-4">
        <b-form-group
          :label="uniTranslation('DPW_PAGINATION')"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </div>

      <div class="col-12">
        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
      </div>

      <!-- =================================================== -->
      <div class="col-12">
        <b-table
          id="offer-table"
          selectable
          select-mode="single"
          striped
          responsive
          sort-icon-left
          hover
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items="itemsFiltered"
          :fields="fields"
          :small="true"
          :busy="isBusy"
          sticky-header="70vh"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          :filter-included-fields="filterOn"
          @row-clicked="selectOffer"
          @filtered="onFiltered"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template v-slot:head(offerDate)="data">
            <div class="text-left">{{ data.label }}</div>
          </template>

          <template v-slot:cell(offerDate)="row">
            <div class="text-left">
              {{ new Date(row.item.offerDate).toLocaleDateString() }}
            </div>
          </template>

          <template v-slot:head(totalOfferNetPrice)="data">
            <div class="text-left">{{ data.label }}</div>
          </template>

          <template v-slot:cell(totalOfferNetPrice)="row">
            <div class="text-left">{{ formatMoney(row.item.totalOfferNetPrice) }}</div>
          </template>

          <template v-slot:cell(pubblica)="row">
            <!-- slot="pubblica" slot-scope="row"-->
            <i v-if="row.item.pubblica" class="fa fa-check"></i>
            <i v-if="!row.item.pubblica" class></i>
          </template>
          <template v-slot:cell(edit)="row">
            <!-- slot="edit" slot-scope="row" -->
            <b-button
              v-show="!fromAddToOffer && row.item.proprietario"
              size="sm"
              class="fa fa-pencil"
              @click="rowEditOffer(row.item)"
            ></b-button>
            <b-button
              v-show="!fromAddToOffer && !row.item.proprietario"
              size="sm"
              class="fa fa-search"
              @click="rowEditOffer(row.item)"
            ></b-button>
            &nbsp;
            <b-button
              v-show="!fromAddToOffer"
              size="sm"
              class="fa fa-copy"
              @click="duplicateOffer(row.item)"
            ></b-button>
          </template>
          <template v-slot:cell(delete)="row">
            <!-- slot="delete" slot-scope="row" -->
            <b-button
              v-show="!fromAddToOffer && row.item.proprietario"
              size="sm"
              class="fa fa-trash"
              @click="rowDeleteOffer(row.item)"
            ></b-button>
          </template>
        </b-table>
      </div>
    </div>

    <b-modal v-model="showDelete" :title="uniTranslation('GCN39')" @ok="deleteOffer">
      <p class="my-4">{{ uniTranslation("GCN40") }} {{ delete_to_offer }} ?</p>
    </b-modal>

    <b-modal v-model="showOfferActivated" hide-footer>
      <div class="d-block text-center">
        <h3>{{ uniTranslation("GON105") }}</h3>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import offerteservice from "@/services/backend/offersService";
import colorsService from "@/services/backend/colorsService";
import excelHelper from "@/shared/excelHelper";

export default {
  props: {
    fromAddToOffer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      delete_to_offer: "",
      showDelete: false,
      showSearchPanel: false,
      offerNumberToSearch: "",
      offerDescriptionToSearch: "",
      companyNameToSearch: "",
      attentionToSearch: "",
      offerToDelete: {},
      ricordaIdSelectedOffer: 0,
      showOfferActivated: false,
      items: [],
      itemsFiltered: [
        "id",
        "offerNumber",
        "offerDescription",
        "offerDate",
        "companyName",
        "attention",
        "totalOfferNetPrice"
      ],
      isBusy: false,
      sortBy: "id",
      sortDesc: true,
      compName: "OffertManagement",
      perPage: 30,
      currentPage: 1,
      filter: null,
      filterFake: null,
      filterOn: [],
      rows: 0,
      coloreFooterSfondo: "",
      coloreFooterTesto: "",
      coloreFooterBottoni: "",
      coloreTestoBottoni: "",
      coloreBordoBottoni: "",
      coloreBordo: ""
    };
  },
  computed: {
    pageOptions: function() {
      var options = [10, 20, 30, 50, 100, 200, this.itemsFiltered.length];

      return options.sort(function(a, b) {
        return a - b;
      });
    },
    isAdmin: function() {
      return this.$store.getters.isLoggedUserAdmin;
    },
    isUnilab: function() {
      return this.$store.getters.isLoggedUserUnilab;
    },
    fields: function() {
      if (this.$store.getters.profiloUtente.prezzi) {
        return [
          { key: "id", label: "Id", sortable: true },
          {
            key: "offerNumber",
            label: this.uniTranslation("GO032"),
            sortable: true
          },
          { key: "offerDescription", label: this.uniTranslation("GO034"), sortable: true },
          {
            key: "offerDate",
            label: this.uniTranslation("GO51"),
            sortable: true
          },
          { key: "companyName", label: this.uniTranslation("PHE611"), sortable: true },
          { key: "attention", label: this.uniTranslation("S1102"), sortable: true },
          { key: "totalOfferNetPrice", label: this.uniTranslation("GO044"), sortable: true },
          { key: "pubblica", label: this.uniTranslation("GCN37"), sortable: true },
          { key: "edit", label: "" },
          { key: "delete", label: "" }
        ];
      } else {
        return [
          { key: "id", label: "Id", sortable: true },
          {
            key: "offerNumber",
            label: this.uniTranslation("GO032"),
            sortable: true
          },
          { key: "offerDescription", label: this.uniTranslation("GO034"), sortable: true },
          {
            key: "offerDate",
            label: this.uniTranslation("GO51"),
            sortable: true
          },
          { key: "companyName", label: this.uniTranslation("PHE611"), sortable: true },
          { key: "attention", label: this.uniTranslation("S1102"), sortable: true },
          { key: "pubblica", label: this.uniTranslation("GCN37"), sortable: true },
          { key: "edit", label: "" },
          { key: "delete", label: "" }
        ];
      }
    }
  },
  watch: {
    itemsFiltered: function() {
      this.filter = "";
      this.filterFake = "";
      this.rows = this.itemsFiltered.length;
    },
    offerNumberToSearch: function(newVal, oldVal) {
      this.offerNumberToSearch = String("");
      if (newVal) this.offerNumberToSearch = String(newVal).trim();

      this.filterItems();
    },
    offerDescriptionToSearch: function(newVal, oldVal) {
      this.offerDescriptionToSearch = String("");
      if (newVal) this.offerDescriptionToSearch = String(newVal).trim();

      this.filterItems();
    },
    companyNameToSearch: function(newVal, oldVal) {
      this.companyNameToSearch = String("");
      if (newVal) this.companyNameToSearch = String(newVal).trim();

      this.filterItems();
    },
    attentionToSearch: function(newVal, oldVal) {
      this.attentionToSearch = String("");
      if (newVal) this.attentionToSearch = String(newVal).trim();

      this.filterItems();
    }
  },
  mounted: function() {
    //var that = this;
    //offerteservice.getUserCustomers().then(function(data) {
    //that.items = data;var that = this;
    var that = this;

    document.getElementById("mainOverlay").setAttribute("style", "display: none;");

    document.getElementById("mainRouterView").setAttribute("style", "");
    var colorList = colorsService.getColoriFooter();

    that.coloreFooterSfondo = colorList[0];
    that.coloreFooterTesto = colorList[1];
    that.coloreFooterBottoni = colorList[2] + " !important";
    that.coloreTestoBottoni = colorList[3];
    that.coloreBordoBottoni = colorList[4];
    that.coloreBordo = colorList[5];
    //==========================================
    //MARCO DC 20/07/2021
    //Aggiunto su loro richiesta per mettere i titoli dei tab personalizzati
    that.impostaTitolo();
    document.getElementById("currentComponent").value = this.compName;

    that.$store.subscribe(function(mutation /*, state*/) {
      var comp = document.getElementById("currentComponent").value;

      if (mutation.type === "changeLanguage" && comp == that.compName) {
        that.impostaTitolo();
      }
    });
    //==========================================

    this.readOffers();

    //});
  },
  methods: {
    impostaTitolo: function() {
      const title = document.getElementById("title");
      title.innerHTML = this.$t("PHETITLEGESTOFFERTE");
    },
    filterOffers() {
      if (this.filter + "" != this.filterFake + "") {
        this.isBusy = true;
        this.filter = this.filterFake;
      }
    },
    onFiltered(filteredItems) {
      this.isBusy = false;
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    setActiveOffer() {
      this.$store.commit("setIdOffertaAttiva", this.ricordaIdSelectedOffer);
      this.showOfferActivated = true;
    },
    selectOffer(offerta) {
      this.ricordaIdSelectedOffer = offerta.id;
      //alert("riga selezioinata =>" + this.ricordaIdSelectedOffer);
      this.$emit("changeIdSelectedOffer", this.ricordaIdSelectedOffer);
    },
    duplicateOffer(e) {
      var that = this;
      offerteservice.duplicateOffer(e.id).then(() => {
        that.readOffers();
      });
    },
    rowDeleteOffer(e) {
      //alert(e.attention);
      this.offerToDelete = e;
      this.delete_to_offer = e.offerDescription + " - [" + e.offerNumber + "]";
      this.showDelete = true;
    },
    deleteOffer() {
      //alert("cancello =>" + this.customerToDelete.id);
      var that = this;
      //this.items = this.items.filter(x => {
      //   return x.id != that.customerToDelete.id;
      //});
      //mettere il codice che chiama la API per eliminare il cliente
      offerteservice.deleteOffer(that.offerToDelete.id).then(() => {
        if (that.$store.getters.getIdOffertaAttiva) {
          if (that.$store.getters.getIdOffertaAttiva == that.offerToDelete.id) {
            that.$store.commit("resetOffertaAttiva");
          }
        }
        that.readOffers();
      });
    },
    readOffers() {
      var that = this;
      this.isBusy = true;
      offerteservice.getUserOffers().then(function(data) {
        that.items = data;
        that.itemsFiltered = data;
        that.isBusy = false;
      });
    },
    rowEditOffer(e) {
      //var that = this;
      this.$router.push({
        name: "editOfferta",
        params: {
          idOfferta: e.id
        }
      });
    },
    createNewOffer() {
      //var that = this;
      this.$router.push({
        name: "editOfferta",
        params: {
          idOfferta: "-1"
        }
      });
    },
    filterItems() {
      var that = this;

      if (
        !that.offerNumberToSearch &&
        !that.offerDescriptionToSearch &&
        !that.companyNameToSearch &&
        !that.attentionToSearch
      )
        that.itemsFiltered = that.items;
      else
        that.itemsFiltered = that.items.filter(x => {
          var bAdd = true;

          if (!x.companyName) x.companyName = " ";

          if (!x.attention) x.attention = " ";

          if (!x.offerNumber) x.offerNumber = " ";

          if (!x.offerDescription) x.offerDescription = " ";

          if (bAdd && that.companyNameToSearch)
            bAdd =
              bAdd && x.companyName.toLowerCase().includes(that.companyNameToSearch.toLowerCase());

          if (bAdd && that.attentionToSearch)
            bAdd = bAdd && x.attention.toLowerCase().includes(that.attentionToSearch.toLowerCase());

          if (bAdd && that.offerNumberToSearch)
            bAdd =
              bAdd && x.offerNumber.toLowerCase().includes(that.offerNumberToSearch.toLowerCase());

          if (bAdd && that.offerDescriptionToSearch)
            bAdd =
              bAdd &&
              x.offerDescription
                .toLowerCase()
                .includes(that.offerDescriptionToSearch.toLowerCase());

          return bAdd;
        });
    },
    esportaCSVOffers() {
      var expArr = [];

      this.itemsFiltered.forEach(x => {
        var myX = {
          id: x.id,
          offerNumber: x.offerNumber,
          offerDescription: x.offerDescription,
          offerDate: x.offerDate,
          companyName: x.companyName,
          attention: x.attention,
          totalOfferNetPrice: x.totalOfferNetPrice.toFixed(2).replace(".", ","),
          pubblica: x.pubblica
        };

        expArr.push(myX);
      });

      excelHelper.csvExport(expArr, String("OffersListExportation.csv"));
    }
  }
};
</script>

<style>
table.b-table-selectable > tbody > tr.b-table-row-selected > td,
table.b-table-selectable > tbody > tr.b-table-row-selected > th {
  background-color: #85d7f5e8 !important; /*  var(--info) */
}
</style>
